module.exports = __webpack_public_path__ + "img/UI_common_title_help_02_en_3edc74439.png";